import React from 'react';
import './Styles/Banner.scss';

const Banner=()=>{
    return(
        <div className="monzo-banner">

        </div>
    )
};
export default Banner ;